import { useState, useEffect } from 'react';

function formatDuration(startedAt: string): string {
  const ms = Date.now() - new Date(startedAt).getTime();
  const totalSec = Math.floor(ms / 1000);
  const h = String(Math.floor(totalSec / 3600)).padStart(2, '0');
  const m = String(Math.floor((totalSec % 3600) / 60)).padStart(2, '0');
  const s = String(totalSec % 60).padStart(2, '0');
  return `${h}:${m}:${s}`;
}

interface StatusClockProps {
  statusLabel: string;
  statusStartedAt: string | null;
  isClockedIn: boolean;
  productiveMinutes: number;
}

export function StatusClock({
  statusLabel,
  statusStartedAt,
  isClockedIn,
  productiveMinutes,
}: StatusClockProps) {
  const [clockDisplay, setClockDisplay] = useState('00:00:00');

  useEffect(() => {
    if (!isClockedIn || !statusStartedAt) {
      setClockDisplay('00:00:00');
      return;
    }
    const tick = () => setClockDisplay(formatDuration(statusStartedAt));
    tick();
    const interval = setInterval(tick, 1000);
    return () => clearInterval(interval);
  }, [isClockedIn, statusStartedAt]);

  return (
    <div className="flex flex-col items-center gap-0.5">
      <div className="px-3 py-1 bg-secondary/30 border border-border/60 rounded-lg text-[0.6875rem] font-mono font-medium text-foreground shadow-inner flex items-center gap-2 min-w-[120px] justify-center">
        <span className="text-muted-foreground text-[0.5625rem] uppercase font-sans">
          {statusLabel}
        </span>
        {clockDisplay}
      </div>
      {isClockedIn && (
        <span className="text-[0.5625rem] text-muted-foreground font-medium">
          Productive: {Math.floor(productiveMinutes / 60)}h {productiveMinutes % 60}m
        </span>
      )}
    </div>
  );
}
